export const DTL_DATA_SERVICE = 'dtl-data-service/v1';
export const TEMPLATE_BROWSER_URL = 'dtl-data-service/v1/templates/browse';
export const TEMPLATE_URL = 'dtl-data-service/v1/templates';
export const INITIATE_TEMPLATE_URL = 'dtl-data-service/v1/templates/initiate';
export const ESYS_EDK_DOC_URL = 'esys-data-service/v1/esys/service/EDK/doc';
export const SITEDTL_BROWSER_URL = 'dtl-data-service/v1/sitedtls/browse';
export const SITEDTL_URL = 'dtl-data-service/v1/sitedtls';
export const CORE_URL = 'core-service/v1';
export const TASK_ASGN_BROWSER_URL = 'dtl-data-service/v1/taskassignments/browse';
export const TASK_ASGN_URL = 'dtl-data-service/v1/taskassignments';
export const TASK_ASSIGNEE_NAMES_URL = 'dtl-data-service/v1/taskassignments/assigneenames';
export const DTL_PERSON_SEARCH_URL = 'dtl-data-service/v1/taskassignments/persons/autocomplete';
export const DTL_ASSIGNEE_SEARCH_URL = 'dtl-data-service/v1/taskassignments/assigneenames/autocomplete';
export const REQUEST_URL = 'dtl-data-service/v1/requests';
export const DASHBOARD_URL = 'dtl-data-service/v1/dashboard';
